import { getShape1D } from 'ml-peak-shape-generator';
/**
 * Append 2 properties to the peaks, shape and fwhm
 */
export function appendShapeAndFWHM(peaks, options = {}) {
    let { shape = { kind: 'gaussian' } } = options;
    let widthToFWHM = getShape1D(shape).widthToFWHM;
    return peaks.map((peak) => ({
        ...peak,
        shape: { fwhm: widthToFWHM(peak.width), ...shape },
    }));
}
//# sourceMappingURL=appendShapeAndFWHM.js.map